/* MoRetro Studio V24.4 — Sendcloud labels */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const API_BASE = "https://bubbly-vibrancy-production.up.railway.app";

  function esc(v){
    return MTS.escapeHtml ? MTS.escapeHtml(v) : String(v ?? "").replace(/[&<>"']/g, m=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[m]));
  }

  function parsePickupFromOrder(order = {}){
    const attrs = order.customAttributes || order.attributes || order.noteAttributes || [];
    const map = {};
    if(Array.isArray(attrs)){
      attrs.forEach(a=>{
        const k = a.key || a.name || "";
        const v = a.value || "";
        if(k) map[k] = v;
      });
    }

    return {
      carrier: map["Point relais - Transporteur"] || order.pickupCarrier || "",
      id: map["Point relais - ID"] || order.pickupId || "",
      name: map["Point relais - Nom"] || order.pickupName || "",
      address: map["Point relais - Adresse"] || order.pickupAddress || "",
      postalCode: map["Point relais - Code postal"] || order.pickupZip || "",
      city: map["Point relais - Ville"] || order.pickupCity || "",
      country: map["Point relais - Pays"] || "FR"
    };
  }

  function projectAddress(project = {}){
    return project.shippingAddress || project.address || {
      name:project.name || project.customerName || "",
      address1:project.address1 || "",
      zip:project.zip || project.postalCode || "",
      city:project.city || "",
      country:"FR",
      phone:project.phone || ""
    };
  }

  function defaultWeightFromItems(items = []){
    const totalQty = items.reduce((s,i)=>s+Number(i.quantity||1),0) || 1;
    return Math.max(0.2, totalQty * 0.18);
  }

  function shippingPayloadFromOrder(order){
    const pickup = parsePickupFromOrder(order);
    return {
      source:"shopify_order",
      order:{
        id:order.id,
        name:order.name,
        customerName:order.customerName,
        email:order.email,
        phone:order.phone,
        total:order.total,
        currency:order.currency || "EUR",
        shippingAddress:order.shippingAddress || {},
        pickupId:pickup.id,
        servicePointId:pickup.id
      },
      pickup,
      items:order.items || [],
      weightKg:defaultWeightFromItems(order.items || []),
      carrier:pickup.carrier || order.shippingCarrier || order.shippingLineTitle || order.shippingMethod || ""
    };
  }

  function shippingPayloadFromProject(project){
    const lines = project.productionLines || [];
    const items = lines.length ? lines.map(l=>({title:l.title, quantity:l.quantity || 1, sku:l.sku || ""})) : [{title:project.projectType || "Projet sur mesure", quantity:1}];

    return {
      source:"custom_project",
      order:{
        id:project.id || project.docId || "",
        name:project.shopifyOrderName || project.shopify?.name || project.id || "Projet sur mesure",
        customerName:project.name || project.customerName,
        email:project.email,
        phone:project.phone,
        total:project.finalPrice || project.quoteTotal || project.quote?.total || 0,
        currency:"EUR",
        shippingAddress:projectAddress(project)
      },
      pickup:project.pickup || {},
      items,
      weightKg:defaultWeightFromItems(items),
      carrier:project.shippingCarrier || project.shippingMethod || project.pickup?.carrier || ""
    };
  }


  async function fulfillShopifyOrderAfterLabel(payload, labelData){
    if(payload.source !== "shopify_order") return null;

    const orderId = payload.order?.id || payload.order?.shopifyOrderId || "";
    if(!orderId) return null;

    const trackingNumber = labelData.trackingNumber || labelData.parcel?.tracking_number || labelData.parcel?.tracking_code || "";
    const trackingUrl = labelData.trackingUrl || labelData.parcel?.tracking_url || "";
    const trackingCompany =
      labelData.chosenMethod?.carrier ||
      payload.carrier ||
      payload.shippingCarrier ||
      payload.pickup?.carrier ||
      "Sendcloud";

    if(!trackingNumber && !trackingUrl) return null;

    const res = await fetch(`${API_BASE}/api/shopify/fulfill-order`,{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({
        orderId,
        trackingNumber,
        trackingUrl,
        trackingCompany,
        notifyCustomer:true
      })
    });

    const data = await res.json().catch(()=>null);
    if(!res.ok || !data?.ok){
      throw new Error(data?.error || `Erreur Shopify fulfillment ${res.status}`);
    }

    return data;
  }


  function openShippingModal(payload, options = {}){
    document.getElementById("mtsShippingModal")?.remove();

    const pickup = payload.pickup || {};
    const hasPickup = !!(pickup.id || pickup.name);
    const html = `
      <div class="mts-ship-modal" id="mtsShippingModal">
        <div class="mts-ship-card">
          <div class="mts-ship-head">
            <div>
              <h3>📦 Créer une étiquette Sendcloud</h3>
              <p>${esc(payload.order?.name || "Commande")} — ${esc(payload.order?.customerName || "")}</p>
            </div>
            <button type="button" class="mts-ship-close" data-mts-ship-close>×</button>
          </div>

          <div class="mts-ship-grid">
            <label>Poids colis kg
              <input type="number" min="0.01" step="0.01" id="mtsShipWeight" value="${Number(payload.weightKg || 0.25).toFixed(2)}">
            </label>
            <label>Transporteur détecté
              <input id="mtsShipCarrier" placeholder="Mondial Relay / Colissimo..." value="${esc(hasPickup ? (pickup.carrier || "Mondial Relay") : (payload.carrier || payload.shippingCarrier || ""))}">
            </label>
            <details class="mts-ship-advanced">
              <summary>Forcer une méthode</summary>
              <label>ID méthode Sendcloud
                <input type="number" min="1" step="1" id="mtsShipMethodId" placeholder="Auto">
              </label>
            </details>
          </div>

          <div class="mts-ship-box">
            <strong>Adresse</strong>
            <p>${esc(payload.order?.shippingAddress?.name || payload.order?.customerName || "")}<br>
            ${esc(payload.order?.shippingAddress?.address1 || payload.order?.shippingAddress?.address || "")}<br>
            ${esc(payload.order?.shippingAddress?.zip || payload.order?.shippingAddress?.postalCode || "")} ${esc(payload.order?.shippingAddress?.city || "")}</p>
          </div>

          <div class="mts-ship-box ${hasPickup ? "ok" : ""}">
            <strong>Point relais</strong>
            <p>${hasPickup ? `${esc(pickup.name || "")}<br>${esc(pickup.address || "")}<br>${esc(pickup.postalCode || "")} ${esc(pickup.city || "")}` : "Aucun point relais enregistré. L’étiquette sera créée en livraison domicile si la méthode choisie le permet."}</p>
          </div>

          <div class="mts-ship-status" id="mtsShipStatus"></div>

          <div class="mts-ship-actions">
            <button type="button" class="mts-btn mts-soft" data-mts-ship-close>Annuler</button>
            <button type="button" class="mts-btn mts-ok" id="mtsCreateSendcloudLabel">Créer l’étiquette</button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", html);
    injectCss();

    document.querySelectorAll("[data-mts-ship-close]").forEach(btn=>btn.addEventListener("click",()=>document.getElementById("mtsShippingModal")?.remove()));

    document.getElementById("mtsCreateSendcloudLabel")?.addEventListener("click", async()=>{
      const status = document.getElementById("mtsShipStatus");
      const weightKg = Number(document.getElementById("mtsShipWeight")?.value || 0.25);
      const shipmentId = Number(document.getElementById("mtsShipMethodId")?.value || 0);
      const carrier = document.getElementById("mtsShipCarrier")?.value || payload.carrier || payload.shippingCarrier || "";

      const finalPayload = {
        ...payload,
        weightKg,
        carrier,
        shippingCarrier: carrier
      };

      if(shipmentId){
        finalPayload.shipmentId = shipmentId;
      }

      if(status) status.textContent = "Choix automatique de la méthode Sendcloud puis création de l’étiquette...";
      try{
        const res = await fetch(`${API_BASE}/api/sendcloud/create-label`,{
          method:"POST",
          headers:{"Content-Type":"application/json","Accept":"application/json"},
          body:JSON.stringify(finalPayload)
        });
        const data = await res.json().catch(()=>null);
        if(!res.ok || !data?.ok) throw new Error(data?.error || `Erreur Sendcloud ${res.status}`);

        let shopifyFulfillment = null;
        let shopifyMessage = "";

        try{
          shopifyFulfillment = await fulfillShopifyOrderAfterLabel(finalPayload, data);
          if(shopifyFulfillment?.ok){
            shopifyMessage = `<br>✅ Shopify marqué comme expédié`;
          }
        }catch(shopifyErr){
          shopifyMessage = `<br>⚠️ Étiquette créée, mais Shopify n’a pas été marqué expédié : ${esc(shopifyErr.message)}`;
        }

        if(status) status.innerHTML = `✅ Étiquette créée${data.chosenMethod ? `<br>Méthode : ${esc(data.chosenMethod.name || "")} (#${esc(data.chosenMethod.id || "")})` : ""}${data.trackingNumber ? `<br>Suivi : ${esc(data.trackingNumber)}` : ""}${shopifyMessage}${data.labelUrl ? `<br><a href="${esc(data.labelUrl)}" target="_blank" rel="noopener">Ouvrir le PDF</a>` : ""}`;

        if(typeof options.onCreated === "function"){
          await options.onCreated(data, finalPayload, shopifyFulfillment);
        }

        if(data.labelUrl){
          window.open(data.labelUrl, "_blank", "noopener");
        }
      }catch(err){
        if(status) status.textContent = "Erreur : " + err.message;
      }
    });
  }

  function injectCss(){
    if(document.getElementById("mtsShippingCss")) return;
    const style = document.createElement("style");
    style.id = "mtsShippingCss";
    style.textContent = `
      .mts-ship-modal{position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.74);display:grid;place-items:center;padding:20px}
      .mts-ship-card{width:min(820px,100%);max-height:92vh;overflow:auto;border-radius:28px;background:#101018;border:1px solid rgba(255,255,255,.14);box-shadow:0 30px 120px rgba(0,0,0,.55);padding:20px;color:#fff}
      .mts-ship-head{display:flex;justify-content:space-between;gap:16px;align-items:flex-start;margin-bottom:16px}
      .mts-ship-head h3{margin:0;font-size:24px}
      .mts-ship-head p{margin:6px 0 0;color:#aaa}
      .mts-ship-close{border:0;background:rgba(255,255,255,.08);color:#fff;border-radius:14px;width:38px;height:38px;font-size:24px;cursor:pointer}
      .mts-ship-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:12px}
      .mts-ship-grid label{display:grid;gap:7px;font-size:12px;font-weight:900}
      .mts-ship-advanced{grid-column:1/-1;padding:10px 12px;border-radius:14px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08)}
      .mts-ship-advanced summary{cursor:pointer;font-weight:900;color:#00d4ff;margin-bottom:8px}
      .mts-ship-grid input{width:100%;border:1px solid rgba(255,255,255,.14);border-radius:14px;background:#101010;color:#fff;padding:11px 12px;font-family:inherit;outline:none}
      .mts-ship-box{margin-top:12px;padding:14px;border-radius:18px;background:rgba(255,255,255,.045);border:1px solid rgba(255,255,255,.08)}
      .mts-ship-box.ok{border-color:rgba(0,200,83,.28);background:rgba(0,200,83,.08)}
      .mts-ship-box strong{display:block;margin-bottom:6px}
      .mts-ship-box p{margin:0;color:#bbb;line-height:1.45}
      .mts-ship-status{margin-top:12px;color:#ffe84a;font-weight:900;line-height:1.45}
      .mts-ship-status a{color:#00d4ff}
      .mts-ship-actions{display:flex;justify-content:flex-end;gap:10px;margin-top:16px}
      @media(max-width:720px){.mts-ship-grid{grid-template-columns:1fr}.mts-ship-actions{display:grid}}
    `;
    document.head.appendChild(style);
  }

  MTS.Shipping = {
    shippingPayloadFromOrder,
    shippingPayloadFromProject,
    parsePickupFromOrder,
    openShippingModal
  };
})(window.MTS);

